import React from 'react';

const refine = (n, options) => {
  options = options || {};
  var d = options.delimiter || ',';
  var s = options.separator || '.';
  n = n.toString().split('.');
  n[0] = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + d);
  return n.join(s);
};

const RefineNumber = ({ number, options }) => (
  <div>{refine(number, options)}</div>
);

export default RefineNumber;
